import { EXAM_CONFIG } from "../utils/AssessmentStrings";
import CameraRecorder from "./AssessmentCamRecorder";
import ScreenRecorder from "./AssessmentScreenRecorder";
import { useProctoring } from "../hooks/ActiveProctoringContext";
const AssessmentProctoringLayer = () => {
  const {
    setupStep,
    isCameraStarted,
    isScreenStarted,
    cameraStream,
    setCameraStream,
    handlePermissionDenied,
    handleScreenPermissionDenied,
    handleScreenStreamStop,
    screenPermissionDenied,
    setSetupStep,
    isProctoringActive,
    isFaceDetected,
    isObjectDetected,
    isMultiFaceDetected,
    isPositionWrong,
    isBlurred,
    hasMalpracticeHistory,
  } = useProctoring();

  return (
    <>
      {isCameraStarted && (
        <CameraRecorder
          onPermissionDenied={handlePermissionDenied}
          onStream={(stream) => {
            setCameraStream(stream);

            if (setupStep === "camera") {
              setSetupStep("screen");
            }
          }}
          isActive={setupStep === "ready"}
          captureInterval={
            !isFaceDetected ||
            isObjectDetected ||
            isMultiFaceDetected ||
            isPositionWrong ||
            isBlurred ||
            hasMalpracticeHistory
              ? EXAM_CONFIG.MALPRACTICE_CAPTURE_INTERVAL_MS
              : undefined
          }
        />
      )}

      {isScreenStarted &&
        // isProctoringActive &&
        (setupStep === "screen" ||
          setupStep === "ready_to_start" ||
          setupStep === "ready") &&
        !screenPermissionDenied && (
          <ScreenRecorder
            onPermissionDenied={handleScreenPermissionDenied}
            onReady={() => {
              if (setupStep === "screen") {
                setSetupStep("ready_to_start");
              }
            }}
            onStreamStop={handleScreenStreamStop}
          />
        )}

      {/* {(setupStep === "ready_to_start" || setupStep === "ready") &&
        isAtAssessmentPage && <CameraPopup stream={cameraStream} />} */}
    </>
  );
};

export default AssessmentProctoringLayer;
